import { Box, Skeleton, Typography } from '@mui/material'
import React, { useEffect, useState, useCallback } from 'react'
import LookUpTable from './LookUpTable'
import TradingWidget from '@/src/components/TradingWidget'
import CommonApi from '@/pages/api'

const MarketData = ({
  marketData,
  newMarketData = {},
  loading,
  newGraph = false,
  sectionId = 7,
  isDraft = false
}) => {
  const [isloading, setIsLoading] = useState(false)
  const [chartSection, setChartSection] = useState()

  const fetcChartSections = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await CommonApi({
        method: 'get',
        path: `show-chart/${sectionId}${isDraft ? '?status=draft' : ''}`
      })
      if (response?.status) {
        setChartSection(response?.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }, [sectionId, isDraft])

  useEffect(() => {
    if (newGraph) {
      fetcChartSections()
    }
  }, [newGraph, fetcChartSections])

  return (
    <>
      {newGraph ? (
        (chartSection?.show_score_cards || chartSection?.show_price_chart) && (
          <Box className={`flex flex-col gap-y-8`}>
            {loading && isloading ? (
              <Skeleton className="h-[29.563rem]" />
            ) : newGraph ? (
              <>
                <Box className="flex flex-col lg:flex-row gap-4">
                  <Box className="w-full ">
                    {chartSection?.show_price_chart && (
                      <Box
                        sx={{
                          boxShadow:
                            chartSection?.show_score_cards && chartSection?.show_price_chart
                              ? `
                            -4px 0 6px -1px rgba(0,0,0,0.1),
                            4px 0 6px -1px rgba(0,0,0,0.1)`
                              : undefined
                        }}
                        className={` overflow-hidden ${!(chartSection?.show_score_cards && chartSection?.show_price_chart) ? 'shadow-md rounded-2xl' : 'rounded-t-2xl'}`}
                      >
                        <TradingWidget defaultPeriod={chartSection?.price_chart_default_period} />
                      </Box>
                    )}
                    {chartSection?.show_score_cards && (
                      <Box
                        sx={{
                          boxShadow:
                            chartSection?.show_score_cards && chartSection?.show_price_chart
                              ? `0 -4px 6px -1px rgba(0,0,0,0.1),
                            -4px 0 6px -1px rgba(0,0,0,0.1),
                            4px 0 6px -1px rgba(0,0,0,0.1)`
                              : undefined
                        }}
                        className={` overflow-hidden ${!(chartSection?.show_score_cards && chartSection?.show_price_chart) ? 'shadow-md rounded-2xl' : 'rounded-b-2xl'}`}
                      >
                        <LookUpTable
                          newGraph={newGraph}
                          marketData={marketData}
                          newMarketData={newMarketData}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              </>
            ) : (
              <TradingWidget />
            )}

            {!newGraph && <LookUpTable marketData={marketData} />}
          </Box>
        )
      ) : (
        <Box className="flex flex-col gap-y-8">
          <Typography variant="h5">Market Data</Typography>

          {loading ? <Skeleton className="h-[29.563rem]" /> : <TradingWidget />}
          <LookUpTable marketData={marketData} />
        </Box>
      )}
    </>
  )
}

export default MarketData
